// extracted by mini-css-extract-plugin
export default {"Contacts":"contacts_Contacts__JLao+","sendQuestion":"contacts_sendQuestion__4gQQO","MessageSuccessSended":"contacts_MessageSuccessSended__ly9pg"};